// HeroHeader.tsx - VERSIÓN OPTIMIZADA
"use client";
import Box from '@mui/material/Box';
import { useEffect, useState, useRef } from 'react';
import { heroSettings } from '@/data/heroData';
import HeroMainContent from './HeroMainContent';
import AboutSection from './AboutSection';
import Image from 'next/image';

export default function HeroHeader() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsVisible(true);
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={sectionRef}
      sx={{
        position: 'relative',
        minHeight: { xs: 'auto', md: '100vh' },
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      {/* IMAGEN DE FONDO OPTIMIZADA */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
        }}
      >
        <Image
          src={heroSettings.imageUrl}
          alt="Faro en la costa al atardecer - Vixia System"
          fill
          // priority={true}  
          quality={85}     
          sizes="100vw"    
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
          }}
          loading='eager'
          fetchPriority="high"
        />
      </Box>

      {/* Overlay oscuro */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%)',
          zIndex: 1,
        }}
      />

      {/* Contenido principal */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          py: { xs: 6, md: 8 },
          px: { xs: 2, sm: 3, md: 4, lg: 8, xl: 16 },
          color: 'white',
        }}
      >
        <HeroMainContent isVisible={isVisible} />
        <AboutSection isVisible={isVisible} />
      </Box>
    </Box>
  );
}